import * as Yup from 'yup';
import { PqrProductData } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrProductData = {
    policy: '',
    bonusValue: '',
    plate: '',
};

export const validationSchema = Yup.object({
    policy: Yup.string()
        .max(
            100,
            'La póliza debe tener 100 caracteres alfanuméricos como máximo'
        )
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'La póliza solo debe contener caracteres alfanuméricos'
        ),
    bonusValue: Yup.string()
        .max(
            30,
            'El valor de la prima debe tener 30 caracteres alfanuméricos como máximo'
        )
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'El valor de la prima solo debe contener caracteres alfanuméricos'
        ),
    plate: Yup.string()
        .max(30, 'La placa debe tener 30 caracteres alfanuméricos como máximo')
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'La placa solo debe contener caracteres alfanuméricos'
        ),
});
